import { FieldMessage, Label, TextInput } from '@elladx/design-system';

export default function ProductField({ idPrefix, value, onChange, required = false, readOnly = false, error }: {
  idPrefix: string; value?: string; onChange: (value: string) => void; required?: boolean; readOnly?: boolean; error?: string;
}) {
  const id = `${idPrefix}-product_name`;
  return <div className="form-group full-width">
    <Label htmlFor={id}>Product being shipped{required ? ' *' : ''}</Label>
    <TextInput id={id} value={value || ''} onChange={event => onChange(event.target.value)} required={required} readOnly={readOnly}
      maxLength={200} placeholder="Product name" invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : undefined}/>
    {error && <FieldMessage id={`${id}-error`} error>{error}</FieldMessage>}
  </div>;
}
